// @flow
import type { State } from '../types';

const subStateSelector = (state: State) => state.zones;

export const listsSelector = (state: State) => {
    const subState = subStateSelector(state);
    return subState.lists;
};

export const entitiesSelector = (state: State) => {
    const subState = subStateSelector(state);
    return subState.entities;
};

export const permanentListSelector = (state: State) => {
    const lists = listsSelector(state);
    return lists.permanent;
};

export const temporaryListSelector = (state: State) => {
    const lists = listsSelector(state);
    return lists.temporary;
};

export const makeEntitySelector = (id: string) => (state: State) => {
    const entities = entitiesSelector(state);
    return entities[id];
};

export const drawingSelector = (state: State) => {
    const subState = subStateSelector(state);
    return subState.drawing;
};

export const drawingShapeTypeSelector = (state: State) => {
    const drawing = drawingSelector(state);
    return drawing && drawing.type;
};

export const drawingShapeSelector = (state: State) => {
    const drawing = drawingSelector(state);
    return drawing && drawing.shape;
};

export const drawingZoneSelector = (state: State) => {
    const drawing = drawingSelector(state);
    return drawing && drawing.zone;
};